import { render, staticRenderFns } from "./AdminInterfaces.vue?vue&type=template&id=e8e27e86&"
import script from "./AdminInterfaces.vue?vue&type=script&lang=ts&"
export * from "./AdminInterfaces.vue?vue&type=script&lang=ts&"
import style0 from "./AdminInterfaces.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports